<div class="school-category-wrapper d-flex flex-md-wrap flex-column flex-md-row">
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('science'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 50 50">
        <use href="#new-science" />
      </svg>
    </div>
    <div class="title">STEM</div>
  </div>
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('business'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 50 50">
        <use href="#new-business" />
      </svg>
    </div>
    <div class="title">Business</div>
  </div>
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('community-service'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 50 50">
        <use href="#new-target" />
      </svg>
    </div>
    <div class="title">Community Service</div>
  </div>
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('humanities'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 50 50">
        <use href="#new-idea" />
      </svg>
    </div>
    <div class="title">Humanities</div>
  </div>
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('social-sciences'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 54 54">
        <use href="#new-connection" />
      </svg>
    </div>
    <div class="title">Social Sciences</div>
  </div>
  <div
    class="school-category d-flex flex-column align-items-center justify-content-center"
    (click)="onSelect('other'); false"
  >
    <div class="icon">
      <svg viewBox="0 0 50 50">
        <use href="#new-clipboards" />
      </svg>
    </div>
    <div class="title">Other</div>
  </div>
</div>
